import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider as Provider } from '@auth0/auth0-react';

const Auth0Provider = props => {
	const { children } = props;
	const navigate = useNavigate();
	const propsToPass = { ...props };
	delete propsToPass.children;

	return (
		<Provider
			domain="blueprint-nyc.auth0.com"
			clientId="F8wIGfq1Z9ZC30BeRaKqIilc7wIAKLwv"
			redirectUri={window.location.origin + '/auth0callback'}
			audience="https://blueprint-nyc.auth0.com/api/v2/"
			scope="read:current_user update:current_user_metadata"
			useRefreshTokens={true}
			// The default replaces history.state, losing the router index that a blocked Back needs.
			onRedirectCallback={appState =>
				navigate(appState?.returnTo || window.location.pathname, { replace: true })
			}
		>
			{React.cloneElement(children, propsToPass)}
		</Provider>
	);
};

export default Auth0Provider;
